import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { isEmpty } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { IPermits } from '../insecta.models';

@Injectable({
  providedIn: 'root'
})
export class PermitsAdminService extends InsectaServiceBase {
  public addPermits(permits: IPermits): Observable<string> {
    return this.post<string>(`/admin/permits`, `v1`, {
      name: permits.name,
      isActive: permits.isActive,
      username: permits.actionBy
    });
  }

  public getPermit(id: string): Observable<IPermits> {
    return this.get<IPermits>(`/admin/permits/${id}`, 'v1');
  }

  public getPermits(includeInActive: boolean | null | undefined): Observable<IPermits[]> {
    if (isEmpty(includeInActive)) includeInActive = false;

    return this.get<IPermits[]>(`/admin/permits`, 'v1').pipe(
      map((results) => [...results].filter((x: IPermits) => includeInActive || x.isActive)),
      map((results) =>
        [...results].sort((a: IPermits, b: IPermits) => (a.isActive == b.isActive ? (a.name > b.name ? 1 : -1) : a.isActive < b.isActive ? 1 : -1))
      )
    );
  }

  public getPermitsAll(): Observable<IPermits[]> {
    return this.getPermits(true);
  }

  public updatePermits(permit: IPermits): Observable<any> {
    return this.put<IPermits>(`/admin/permits/${permit.id}`, `v1`, {
      id: permit.id,
      name: permit.name,
      isActive: permit.isActive,
      username: permit.actionBy,
      uploadId: permit.uploadId,
      fileName: permit.fileName
    });
  }
}
